module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/id_shikoku-95b1777cc61579ec962ded70e9925194.jpg";